import React, { useEffect } from 'react';
import Confetti from 'react-confetti';
import './celebrationalert.css'; // Import your CSS file

function CelebrationAlert() {
  useEffect(() => {
    const startit = () => {
      console.log("start");
      // Add your logic to start the confetti here
    };

    const stopit = () => {
      console.log("stop");
      // Add your logic to stop the confetti here
    };

    const startTimeout = setTimeout(startit, 1000);
    const stopTimeout = setTimeout(stopit, 6000);

    return () => {
      clearTimeout(startTimeout);
      clearTimeout(stopTimeout);
    };
  }, []); // Empty dependency array to run this effect only once

  return (
    <div className='celebratetion'>
      <div className="main_header">
        <div className="center_div">
          <p>
            Wellcome 
            <br />
            🎂And Thank To Visit My Portfilio 🎂
          </p>
        </div>
      </div>
      <Confetti /> {/* Use the Confetti component */}
      {/* Your component JSX */}
    </div>
  );
}

export default CelebrationAlert;
